import { Player } from 'fl-player-interface';
import { ResourceVm } from 'qp-ui-interface';
import { NavigationService } from '../../../shared/services/navigation.service';
import { WindowRefService } from '../../../shared/services/windowRef.service';
import { getDrmScheme } from '../../../shared/utils/PlaybackUtils';
import {
  NRPlaybackStatistics,
  PlaybackDrmInfo,
  SubtitleInfo,
} from '../model/newrelic.model';

export const getSubtitleInfo = (
  player: Player,
  audioLanguage?: string
): SubtitleInfo => {
  const ccEnabled = !!(
    player &&
    player?.getActiveTracks()?.find((element) => element?.type === 'text')
  );
  return {
    audioLanguage,
    ccEnabled,
  };
};

export const getPlaybackDrmInfo = (): PlaybackDrmInfo => {
  return {
    drmName: getDrmScheme().toString(),
    drmVersion: undefined,
  };
};

export const getNRPlaybackStatistics = (
  player: Player,
  resource: ResourceVm,
  navigationService?: NavigationService,
  windowRef?: WindowRefService,
  resolution?: { width: number; height: number }
): NRPlaybackStatistics => {
  const video = document.getElementsByTagName('video')[0];
  const playbackStatistics = player?.playbackStatistics;
  const runningTime = resource?.runningTime;
  const durationHour = runningTime?.includes('h')
    ? parseInt(runningTime, 10) * 3600
    : '';
  const durationMin =
    durationHour !== ''
      ? parseInt(runningTime?.split(' ')[1], 10) * 60
      : parseInt(runningTime, 10) * 60;
  const contentDuration =
    durationHour !== '' ? durationHour + durationMin : durationMin;
  return {
    contentDurationSec: player?.duration
      ? player?.duration
      : Math.floor(video?.duration) || contentDuration,
    videoResolution: `${resolution?.width}x${resolution?.height}`,
    currentBandwidthKb:
      playbackStatistics?.variantBitrate ||
      //@ts-ignore
      windowRef.nativeWindow?.navigator?.connection?.downlink,
    highestVariantBandwidthKb:
      player?.availableBitrates?.[player?.availableBitrates?.length - 1] || -1,
    lowestVariantBandwidthKb: player?.availableBitrates?.[0] || -1,
    lastPlayedVariant: playbackStatistics?.variantBitrate,
    lastAttemptedVariant: playbackStatistics?.variantBitrate,
    searchItemPosition: resource?.ex_id || undefined,
    observedBandwidth: playbackStatistics?.requiredBandwidth || 0,
    estimatedBandwidth: playbackStatistics?.estimatedBandwidth || 0,
    videoBitrate: playbackStatistics?.videoBitrate || 0,
    playerLoadLatency: playbackStatistics?.loadLatency || 0,
  };
};
